import React from "react";

const BackSpaWellness = () => {
  return (
    <div className="headSpaHeadContainer">
      <h2>A Holistic Approach to Wellness</h2>
      <p>
        At SCENT, <a href="https://scentlifestyle.com/spa">back massage</a> is
        not just a standalone service but part of a broader approach to
        wellness. The salon offers a range of other treatments, including{" "}
        <a href="https://scentlifestyle.com/spa">full-body massages</a>,{" "}
        <a href="https://scentlifestyle.com/facial">facials</a>, and{" "}
        <a href="https://scentlifestyle.com/spa">spa therapies</a>, all designed
        to promote overall well-being. This holistic approach ensures that
        clients can enjoy a comprehensive wellness experience, addressing both
        physical and mental health.
      </p>
    </div>
  );
};

export default BackSpaWellness;
